module.exports = "/_next/static/files/d40dae11afa9df3f208da77613a07437.jpg";